(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iml-artwork-library"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-artwork-sign-in]');
  if (!link) return;
  const destination = new URL(link.href, window.location.origin);
  if (destination.origin === window.location.origin && destination.searchParams.has('return_to')) {
    destination.searchParams.set('return_to', window.location.pathname + window.location.search);
    link.href = destination.href;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iml-portrait-experience"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('iml-portrait-experience')){
class IMLPortraitExperience extends HTMLElement{
connectedCallback(){
 const params=new URLSearchParams(window.location.search);const requested=params.get('iml_category');this.category=['women','men','couples','best'].includes(requested)?requested:'all';this.query=params.get('iml_search')||'';
 this.men=this.dataset.men.split('|').map(s=>s.trim());this.couples=this.dataset.couples.split('|').map(s=>s.trim());this.best=this.dataset.bestsellers.split('|').map(s=>s.trim());
 const variantData=JSON.parse(this.querySelector('[data-variants]').textContent);this.variants=variantData.styles.map((option1,index)=>({option1,option2:variantData.rush[index],price:variantData.prices[index],mediaId:variantData.media[index]}));this.strings=JSON.parse(this.querySelector('[data-strings]').textContent);this.currency=JSON.parse(this.querySelector('[data-currency]').textContent);
 this.scope=document.querySelector('product-info');if(!this.scope)return;
 this.scope.classList.add('iml-portrait-page');
 this.onToolsInput=e=>{if(!e.target.matches('.iml-style-tools input[type=search]'))return;e.stopPropagation();this.query=e.target.value;this.category='all';this.filter()};
 this.onToolsClick=e=>{const button=e.target.closest('.iml-style-tools [data-category],.iml-clear-search');if(!button)return;e.preventDefault();e.stopPropagation();if(button.dataset.category||button.classList.contains('iml-clear-search')){this.category=button.dataset.category||'all';this.query='';const input=this.scope.querySelector('.iml-style-tools input');if(input)input.value=''}this.filter()};
 this.onToolsEvent=e=>{if(e.target.closest('.iml-style-tools,.iml-browse'))e.stopPropagation()};
 this.onToolsKey=e=>{const target=e.target.closest('label[data-show],.ymq_upload_new');if(target&&(e.key==='Enter'||e.key===' ')){e.preventDefault();if(target.matches('label'))target.click();else target.querySelector('input[type=file]')?.click()}};
 this.scope.addEventListener('input',this.onToolsInput,true);this.scope.addEventListener('click',this.onToolsClick,true);this.scope.addEventListener('change',this.onToolsEvent,true);this.scope.addEventListener('keyup',this.onToolsEvent,true);this.scope.addEventListener('keydown',this.onToolsKey);
 this.mobileLayout=window.matchMedia('(max-width:749px)');this.onLayout=()=>this.schedule();this.mobileLayout.addEventListener('change',this.onLayout);
 this.observer=new MutationObserver(()=>this.schedule());this.watch();this.setup();
 this.onChange=e=>{this.sync();if(e.target.matches('#option-box-ymq-variant-0 input[type=radio]'))this.previewSelection();clearTimeout(this.syncTimer);this.syncTimer=setTimeout(()=>this.sync(),500)};this.scope.addEventListener('change',this.onChange);
 this.onStyleClick=e=>{const label=e.target.closest('#option-box-ymq-variant-0 label[data-show]');if(!label)return;clearTimeout(this.styleClickTimer);this.styleClickTimer=setTimeout(()=>{const input=document.getElementById(label.htmlFor);if(input&&!input.disabled&&!input.checked)input.click();this.sync();if(input?.checked)this.previewSelection()},0)};this.scope.addEventListener('click',this.onStyleClick,true);
 this.galleryObserver=new MutationObserver(()=>this.syncMedia());const gallery=this.scope.querySelector('media-gallery');if(gallery)this.galleryObserver.observe(gallery,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});this.syncMedia();
}
watch(){this.observer.observe(this.scope,{childList:true,subtree:true})}
disconnectedCallback(){this.mobileLayout?.removeEventListener('change',this.onLayout);this.observer?.disconnect();this.scope?.removeEventListener('change',this.onChange);this.scope?.removeEventListener('input',this.onToolsInput,true);this.scope?.removeEventListener('click',this.onToolsClick,true);this.scope?.removeEventListener('change',this.onToolsEvent,true);this.scope?.removeEventListener('keyup',this.onToolsEvent,true);this.scope?.removeEventListener('keydown',this.onToolsKey);cancelAnimationFrame(this.frame);cancelAnimationFrame(this.previewFrame);this.galleryObserver?.disconnect();clearTimeout(this.syncTimer);clearTimeout(this.styleClickTimer);this.scope?.removeEventListener('click',this.onStyleClick,true)}
schedule(){if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.setup()})}
copy(selector){return this.querySelector(selector).content.cloneNode(true)}
setup(){
 this.observer.disconnect();
 const box=this.scope.querySelector('#option-box-ymq-variant-0');
 if(box){
  if(!box.querySelector('.iml-style-tools')){
   box.prepend(this.copy('[data-controls]'));box.append(this.copy('[data-more]'));
   box.querySelector('input[type=search]').value=this.query;
  }
  box.querySelectorAll('label[data-show]').forEach(l=>{l.tabIndex=0;l.setAttribute('role','button');l.setAttribute('aria-label',l.dataset.show)});
  const ymq=this.scope.querySelector('#ymq-box');if(!ymq.querySelector('.iml-personalize-heading'))ymq.insertBefore(this.copy('[data-personalize]'),box.nextSibling);
  const sequence=['option-box-ymq-variant-0','.iml-personalize-heading','option-box-1','option-box-2','option-box-3','option-box-ymq-variant-1','option-box-4','ymq-price-addons'];
  const ordered=sequence.map(key=>ymq.querySelector(key.startsWith('.')?key:'#'+key)).filter(node=>node?.parentElement===ymq);const current=Array.from(ymq.children).filter(node=>ordered.includes(node));if(current.some((node,index)=>node!==ordered[index]))ordered.forEach(node=>ymq.append(node));
  const upload=ymq.querySelector('#option-box-4 .ymq_lable');if(upload&&upload.textContent!==this.strings.upload)upload.textContent=this.strings.upload;
  const uploadButton=ymq.querySelector('#option-box-4 .ymq_upload_new');if(uploadButton&&!uploadButton.querySelector('.iml-upload-design')){uploadButton.append(this.copy('[data-upload-design]'));uploadButton.tabIndex=0;uploadButton.setAttribute('role','button');uploadButton.setAttribute('aria-label',this.strings.upload)}
  const uploadBox=ymq.querySelector('#option-box-4');if(uploadBox&&!uploadBox.querySelector('.iml-upload-help'))uploadBox.append(this.copy('[data-upload-help]'));
  this.filter();this.sync();
 }
 const media=this.scope.querySelector('.product__media-wrapper');
 let story=this.scope.querySelector('.iml-left-story');
 if(media&&!story){media.append(this.copy('[data-story]'));story=this.scope.querySelector('.iml-left-story')}
 const storyParent=this.mobileLayout.matches?this.scope.querySelector('.product.grid'):media;
 if(story&&storyParent&&story.parentElement!==storyParent)storyParent.append(story);
 this.watch();
}
filter(){
 const box=this.scope.querySelector('#option-box-ymq-variant-0');if(!box)return;
 const selected=box.querySelector('input:checked')?.value;
 const labels=Array.from(box.querySelectorAll('label[data-show]'));
 const normalize=s=>s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,' ').trim();
 const words=normalize(this.query).split(' ').filter(Boolean);
 let eligible=labels.filter(l=>{const n=l.dataset.show;const category=this.category==='all'||(this.category==='best'&&this.best.includes(n))||(this.category==='men'&&this.men.includes(n))||(this.category==='couples'&&this.couples.includes(n))||(this.category==='women'&&!this.men.includes(n)&&!this.couples.includes(n)&&n!=='Fully Customized');const haystack=normalize(n+' '+(IMLPortraitExperience.keywords[n]||''));return category&&words.every(word=>haystack.includes(word))});
 if(this.category==='all'||this.category==='best')eligible.sort((a,b)=>{const rank=n=>{const index=this.best.indexOf(n);return index<0?this.best.length:index};return rank(a.dataset.show)-rank(b.dataset.show)});
 const shown=eligible;
 labels.forEach(l=>{l.hidden=!shown.includes(l);l.style.order=String(eligible.indexOf(l));l.setAttribute('aria-pressed',String(l.dataset.show===selected))});
 box.querySelectorAll('[data-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.category===this.category)));
 const count=box.querySelector('.iml-count');const countText=shown.length+' '+this.strings.of+' '+eligible.length;if(count.textContent!==countText)count.textContent=countText;
 box.querySelector('.iml-no-results').hidden=eligible.length!==0;box.querySelector('.iml-clear-search').hidden=!this.query;
}
previewSelection(){
 cancelAnimationFrame(this.previewFrame);
 this.previewFrame=requestAnimationFrame(()=>{
  this.previewFrame=0;
  const active=this.scope.querySelector('.product__media-list li.is-active');if(!active)return;
  const header=document.querySelector('.shopify-section-header-sticky');
  const offset=Math.min(header?.getBoundingClientRect().height||0,window.innerHeight*.3)+16;
  const rect=active.getBoundingClientRect();
  if(rect.top>=offset&&rect.top<window.innerHeight-80)return;
  window.scrollTo({top:Math.max(0,window.scrollY+rect.top-offset),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
 });
}
syncMedia(){
 const style=this.scope.querySelector('#option-box-ymq-variant-0 input:checked')?.value;
 const variant=this.variants.find(v=>v.option1===style&&v.mediaId);if(!variant)return;
 const gallery=this.scope.querySelector('media-gallery');const list=gallery?.querySelector('.product__media-list');if(!list)return;
 const mediaId=this.scope.dataset.section+'-'+variant.mediaId;
 const active=Array.from(list.querySelectorAll('[data-media-id]')).find(item=>item.dataset.mediaId===mediaId);if(!active)return;
 list.querySelectorAll('[data-media-id]').forEach(item=>{const selected=item===active;if(item.classList.contains('is-active')!==selected)item.classList.toggle('is-active',selected)});
 if(list.scrollLeft!==0)list.scrollLeft=0;
 const image=active.querySelector('img');if(image&&image.loading!=='eager')image.loading='eager';
 gallery.querySelectorAll('[data-target] button').forEach(button=>{if(button.closest('[data-target]').dataset.target===mediaId){if(button.getAttribute('aria-current')!=='true')button.setAttribute('aria-current','true')}else button.removeAttribute('aria-current')});
}
sync(){
 this.syncMedia();
 const box=this.scope.querySelector('#option-box-ymq-variant-0');if(!box)return;
 const style=box.querySelector('input:checked')?.value;
 box.querySelectorAll('label[data-show]').forEach(l=>l.setAttribute('aria-pressed',String(l.dataset.show===style)));
 const rushLabel=this.scope.querySelector('#option-box-ymq-variant-1 .ymq_lable');
 const options=this.variants.filter(v=>v.option1===style);const normal=options.find(v=>v.option2==='No thanks.');const rush=options.find(v=>v.option2!=='No thanks.');
 if(rushLabel&&normal&&rush){const amount=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.currency}).format((rush.price-normal.price)/100);const title=this.strings.rush+' · +'+amount;if(rushLabel.textContent!==title)rushLabel.textContent=title}
}
}
IMLPortraitExperience.keywords={
 'Cocktail Queen':'martini cocktail drink glass','Cocktail Queen Noir':'martini cocktail drink glass black dark',
 'Bourbon Babe':'bourbon whiskey whisky drink','Bourbon Babe Noir':'bourbon whiskey whisky drink black dark','Bourbon Babe Irish Spirit':'bourbon whiskey whisky irish ireland shamrock st patrick',
 'Modern Legend':'man male gentleman whiskey whisky bourbon','Men of Whiskey':'man male gentleman whisky bourbon drink','Hands Off Her Whiskey':'whisky bourbon drink',
 'Women of the West':'western cowgirl cowboy country ranch','Call Me':'telephone phone retro','Horseplay':'horse horses equestrian riding cowgirl western','Hot Rod':'car cars hotrod automobile classic automotive',
 'Biker Belle':'motorcycle motorbike biker bike riding','Sweeter with Cherries':'cherry cherries fruit','USA 250':'america american patriotic independence july 4th',
 'Bombshell':'glamour glamorous blonde','Marilyn':'hollywood glamour blonde','Night Call':'telephone phone evening','National Beauty':'patriotic america american flag','Smokin Hot':'smoking smoke cigar',
 'Bunny':'rabbit bunny ears','Crowned':'couple couples king queen royalty crown romantic anniversary','Bed of Roses':'flowers floral rose roses romantic','Silver Fox':'car cars automobile classic automotive',
 'Charmed':'witch magic halloween','Lady Luck':'casino gambling cards poker vegas','Showgirl':'vegas las vegas dancer dancing cabaret','Rockabilly':'retro rock roll music',
 'Heartbeat':'medical doctor nurse healthcare','Victoria\'s Gin':'gin cocktail drink','Nurse Betty':'nursing nurse medical healthcare hospital','Freshen Up':'bath bathroom bathing',
 'Under the Rug':'rug retro','Teacher\'s Pet':'teacher teaching classroom school education','Mile HIgh':'airplane flight stewardess attendant airline aviation',
 'Red Hot Rescue':'firefighter fireman fire rescue','Space Queen':'space astronaut galaxy science fiction','Princess Power':'superhero hero heroine comic','Blowout':'hair salon stylist hairdresser beauty',
 'Shopaholic':'shopping shopper fashion','Anchored':'anchor sailor navy nautical sea boat','Bomb Babe':'airplane aviation military bomber pilot','We Can Do It':'rosie riveter strong empowered',
 'Patriot':'patriotic america american flag','Hello Sailor':'sailor navy nautical sea boat','Declassified':'military army uniform','Peacekeeper':'police cop officer law enforcement',
 'Lady Liberty':'america american patriotic statue freedom','4th of July':'fourth july independence america american patriotic flag',
 '19th Hole':'golf golfing golfer sports','Touchdown':'football american football gridiron sports','Play Ball':'baseball softball ball sports','Hat Trick':'hockey ice hockey sports',
 'Slam Dunk':'basketball basketball player sports','Golden Goal':'soccer football goal sports','Easy 8\'s':'pool billiards eight ball sports','Gone Fishing':'fish fishing angler outdoors',
 'Ski Bunny':'ski skiing snow winter sports','Round One':'boxing boxer fight fighter sports','Roller Girl':'roller skating skates derby sports',
 'Mob Boss':'woman female mafia gangster mob suit','Queen of the Sea':'mermaid ocean sea fantasy','Bounty Belle':'pirate pirates ship treasure sea','Lady Lagoon':'water lagoon tropical',
 'Aloha':'hawaii hawaiian tropical beach island','Cleopatra':'egypt egyptian queen ancient','Santa\'s Helper':'christmas xmas santa holiday winter','Cupid\'s Helper':'valentine valentines love cupid',
 'Love Hits Different':'couple couples boxing fighter fight poster romantic anniversary sports','Bubblegum':'bubble gum pink','Pretty in Pink':'martini cocktail pink drink',
 'Fully Customized':'custom bespoke original personalized personalisation personalization'
};
customElements.define('iml-portrait-experience',IMLPortraitExperience);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iml-portrait-history"]) return;
  try {
    
if (!customElements.get('iml-portrait-history')) {
  class IMLPortraitHistory extends HTMLElement {
    connectedCallback() {
      if (this.moving) return;
      if (this.initialized) { this.watch(); this.schedule(); return; }
      this.initialized = true;
      this.scope = document.querySelector('product-info');
      if (!this.scope) return;
      this.strings = JSON.parse(this.querySelector('[data-history-strings]').textContent);
      this.selected = null;
      this.choice = this.querySelector('[data-history-options]');
      if (this.choice) this.choice.id = 'IMLHistory-' + this.dataset.sectionId;
      this.onChange = event => {
        if (!event.target.matches('[data-history-options]')) return;
        event.stopPropagation();
        const option = event.target.selectedOptions[0];
        const previous = this.selected;
        this.selected = option?.value ? { key: option.value, ...option.dataset } : null;
        if (!this.selected && previous && this.findField()?.value === previous.orderName) this.findField().value = '';
        this.applySelection();
      };
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', event => {
        const signIn = event.target.closest('.iml-history-sign-in');
        if (signIn) {
          const destination = new URL(signIn.href, location.href);
          if (destination.searchParams.has('return_to')) {
            destination.searchParams.set('return_to', location.pathname + location.search);
            signIn.href = destination.href;
          }
          return;
        }
        const manual = event.target.closest('[data-history-manual]');
        const next = event.target.closest('[data-history-next]');
        if (!manual && !next) return;
        event.preventDefault(); event.stopPropagation();
        if (next) { this.loadOlder(next); return; }
        const previous = this.selected;
        this.selected = null;
        if (this.choice) this.choice.value = '';
        this.updateProperties(); this.showSelection();
        const field = this.findField();
        if (field) { if (previous && field.value === previous.orderName) field.value = ''; this.signalField(field); field.focus(); field.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      });
      this.onReferenceInput = event => {
        if (this.syncing || event.target !== this.findField()) return;
        if (event.target.value.trim()) this.clearRequiredError();
        if (!this.selected) return;
        if (event.target.value.trim() !== this.selected.orderName.trim()) {
          this.selected = null;
          if (this.choice) this.choice.value = '';
          this.updateProperties(); this.showSelection();
        }
      };
      this.scope.addEventListener('input', this.onReferenceInput, true);
      this.onPurchase = event => {
        const button = event.type === 'click' ? (event.target.closest('button[type="submit"], input[type="submit"], button[name="add"]') || event.target.closest('.product-form__buttons')?.querySelector('button[name="add"]')) : null;
        const form = event.type === 'submit' ? event.target : button?.form;
        if (!form?.matches('form[action*="/cart/add"]')) return;
        const field = this.findField();
        if (!field) return;
        if (this.selected) this.applySelection();
        if (field.value.trim()) { this.clearRequiredError(); return; }
        event.preventDefault(); event.stopImmediatePropagation();
        this.querySelector('[data-history-required-error]').hidden = false;
        const focus = this.choice?.querySelector('option[data-item-id]') ? this.choice : field;
        focus.setAttribute('aria-invalid', 'true');
        focus.focus(); focus.scrollIntoView({ block: 'center', behavior: 'smooth' });
      };
      this.scope.addEventListener('click', this.onPurchase, true);
      this.scope.addEventListener('submit', this.onPurchase, true);
      this.observer = new MutationObserver(() => this.schedule());
      this.refresh();
    }
    disconnectedCallback() {
      if (this.moving) return;
      this.observer?.disconnect();
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
    findField() {
      return [...this.scope.querySelectorAll('#ymq-box input.ymq-input-text')].find(input => /original.*portrait.*order.*number/i.test(input.name));
    }
    watch() { this.observer?.observe(this.scope, { childList: true, subtree: true }); }
    schedule() { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.refresh(); }); }
    refresh() {
      this.observer.disconnect();
      const field = this.findField();
      const app = this.scope.querySelector('#ymq-box');
      if (field && app) {
        if (this.nextElementSibling !== app) { this.moving = true; app.before(this); this.moving = false; }
        this.hidden = false;
        const title = field.closest('.ymq-options-box')?.querySelector('.ymq_lable');
        if (title && title.textContent !== this.dataset.manualLabel) title.textContent = this.dataset.manualLabel;
        if (this.selected && field.value !== this.selected.orderName) {
          field.value = this.selected.orderName;
          this.updateProperties(); this.signalField(field);
        } else this.updateProperties();
        this.updateEmpty();
        this.showSelection();
      }
      this.watch();
    }
    updateEmpty() {
      const empty = this.querySelector('[data-history-empty]');
      if (empty) empty.hidden = !!this.choice?.querySelector('option[data-item-id]');
    }
    signalField(field) {
      this.syncing = true;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
      field.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, key: 'Unidentified' }));
      this.syncing = false;
    }
    applySelection() {
      const field = this.findField();
      if (!field) return;
      if (this.selected) field.value = this.selected.orderName;
      this.updateProperties(); this.signalField(field); this.showSelection();
      if (field.value.trim()) this.clearRequiredError();
    }
    showSelection() {
      const status = this.querySelector('[data-history-status]');
      if (status) status.textContent = this.selected ? this.dataset.selectedLabel.replace('__STYLE__', this.selected.style).replace('__ORDER__', this.selected.orderName) : '';
      this.findField()?.closest('.ymq-options-box')?.classList.toggle('iml-history-reference-selected', !!this.selected);
    }
    clearRequiredError() {
      this.querySelector('[data-history-required-error]').hidden = true;
      this.choice?.removeAttribute('aria-invalid');
      this.findField()?.removeAttribute('aria-invalid');
    }
    updateProperties() {
      const values = this.selected ? {
        'Portrait style': this.selected.style,
        'Original portrait item': this.selected.position,
        '_iml_portrait_order_id': this.selected.orderId,
        '_iml_portrait_line_item_id': this.selected.itemId
      } : {};
      for (const form of this.scope.querySelectorAll('form[action*="/cart/add"]')) {
        form.querySelectorAll('[data-iml-history-property]').forEach(box => {
          if (!(box.dataset.imlHistoryProperty in values)) box.remove();
        });
        Object.entries(values).forEach(([key, value], index) => {
          let box = [...form.querySelectorAll('[data-iml-history-property]')].find(node => node.dataset.imlHistoryProperty === key);
          if (!box) {
            const fieldClass = 'iml-history-property-' + index;
            box = document.createElement('div');
            box.className = 'ymq-options-box iml-history-property-box';
            box.hidden = true;
            Object.assign(box.dataset, { imlHistoryProperty: key, type: '1', name: 'properties[' + key + ']', class: fieldClass, validate: '', onetime: '0', ymqAddToCart: '1' });
            const input = document.createElement('input');
            input.type = 'hidden'; input.name = 'properties[' + key + ']'; input.className = fieldClass; input.dataset.price = '0';
            box.append(input); form.append(box);
          }
          const input = box.querySelector('input');
          if (input.value !== value) input.value = value;
        });
      }
    }
    async loadOlder(link) {
      if (this.loading) return;
      const url = new URL(link.getAttribute('href'), window.location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname) return;
      url.searchParams.set('section_id', this.dataset.sectionId);
      const previewId = new URL(location.href).searchParams.get('preview_theme_id');
      if (previewId) url.searchParams.set('preview_theme_id', previewId);
      this.loading = true; link.textContent = this.strings.loading; link.setAttribute('aria-disabled', 'true');
      const error = this.querySelector('[data-history-error]');
      error.hidden = true;
      this.abort = new AbortController();
      const timeout = setTimeout(() => this.abort.abort(), 15000);
      try {
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: this.abort.signal });
        if (!response.ok) throw new Error('History unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const page = doc.querySelector('[data-iml-history-page][data-signed-in="true"]');
        const choices = page?.querySelector('[data-history-options]');
        if (!choices) throw new Error('History unavailable');
        const existing = new Set([...this.choice.options].map(option => option.value));
        choices.querySelectorAll('optgroup').forEach(group => {
          const clone = group.cloneNode(true);
          clone.querySelectorAll('option').forEach(option => { if (existing.has(option.value)) option.remove(); else existing.add(option.value); });
          if (clone.children.length) this.choice.append(clone);
        });
        const next = page.querySelector('[data-history-next]');
        if (next) { link.href = next.getAttribute('href'); link.textContent = this.strings.older; }
        else link.remove();
        this.updateEmpty();
      } catch (failure) {
        if (this.isConnected) { error.hidden = false; link.textContent = this.strings.older; }
      } finally {
        clearTimeout(timeout); this.loading = false; link.removeAttribute('aria-disabled');
      }
    }
  }
  customElements.define('iml-portrait-history', IMLPortraitHistory);
}

  } catch(e) { console.error(e); }
})();
})();
